<script lang="ts">
    import { Navigation } from "../../utilities/Navigation";
    import {onMount} from "svelte";
    import {_} from "svelte-i18n"

    import ImportList from "./ImportList.svelte";
    import TemplateStandard from "../../shared/TemplateStandard.svelte";
    import IconAdd from "../../shared/Icons/IconAdd.svelte";
    import {currentMainFilter} from "../../../stores/filter";
    import {mainMenu} from "../../../stores/store";
    import Separator from "../../shared/Separator.svelte";
    import ButtonAddSomething from "../../shared/ButtonAddSomething.svelte";
    import TemplateHeaderDuo from "../../shared/TemplateHeaderDuo.svelte";

    onMount(() => {
        $mainMenu.currentPage = 'PageImports';
        $currentMainFilter = null;
        return () => {
            $currentMainFilter = null;
        }
    })

</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderDuo>
            <div slot="main-header">
                {$_('Imports')}
            </div>
            <div slot="main-buttons">
                <ButtonAddSomething text={$_("Upload file")} on:click={()=>{Navigation.navigate('/upload-file')}} />
            </div>
        </TemplateHeaderDuo>
    </div>
    <div slot="content">
        <Separator />
        <ImportList />
    </div>
</TemplateStandard>

<style>

</style>